import { MLSListing, mlsInfoByConstellation1ID } from '@aloft/toolkit-shared';
import { Typography } from '@aloft/toolkit-sui';

import { MLSHeaderType } from '../types.ts';

export const MLSListingIDText = ({
  listingData,
  isPopout,
  headerType,
}: {
  listingData: MLSListing;
  isPopout: boolean;
  headerType: MLSHeaderType;
}) => {
  const mlsName =
    mlsInfoByConstellation1ID(listingData.OriginatingSystemName)?.shortName ?? listingData.MLSName;
  return (
    <Typography
      variant="h3"
      color={headerType === 'images' && !isPopout ? 'surfaceAccent4' : undefined}
    >
      {listingData.ListingId
        ? `${mlsName?.toLocaleUpperCase() ?? ''} # ${listingData.ListingId.toString()}`
        : ''}
    </Typography>
  );
};
